const faqItems = [
  {
    q: '90影视真的完全免费吗？',
    a: '是的，90影视所有内容完全免费在线观看，无需注册会员，无需付费订阅，打开网站即可直接观看所有电影、电视剧、综艺和动漫资源。',
  },
  {
    q: '观看需要安装什么播放器吗？',
    a: '不需要。90影视采用HTML5网页播放技术，使用任何现代浏览器（Chrome、Safari、Edge等）直接打开网站即可观看，无需安装任何插件或播放器。',
  },
  {
    q: '视频画质怎么样？有高清吗？',
    a: '大部分内容都提供1080P高清画质，部分新上线资源还支持4K超清。系统会根据你的网络状况自动调整码率，确保流畅播放。',
  },
  {
    q: '资源更新频率是怎样的？',
    a: '热播剧集每日同步更新，电影、综艺、动漫等资源也保持高频次更新。通常在正版平台更新后24小时内就会上线90影视。',
  },
  {
    q: '手机上看体验好吗？',
    a: '90影视针对移动端做了专门优化，支持手势控制音量亮度，智能记忆播放进度。在手机浏览器打开就能获得流畅的观影体验，还能投屏到电视观看。',
  },
  {
    q: '网站有广告吗？真的不缓冲？',
    a: '90影视全程无任何形式的广告干扰，从打开网站到观看结束都没有广告。我们采用CDN加速和多线路切换技术，确保流畅不缓冲的观影体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">常见问题</h2>
            <p className="text-sm text-gray-500 mt-2">关于90影视，你想知道的都在这里</p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqItems.map((item, idx) => (
              <details key={idx} className="group bg-white rounded-xl border border-gray-100 overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-bold text-gray-800 pr-4">{item.q}</h3>
                  <i className="ri-arrow-down-s-line text-gray-400 group-open:rotate-180 transition-transform duration-300 text-lg w-5 h-5 flex items-center justify-center shrink-0"></i>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-500 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}